// extracted by mini-css-extract-plugin
module.exports = {"pintxo-tab-menu":"TabMenu_pintxo-tab-menu__ZHHPQ","pintxo-tab-menu__container":"TabMenu_pintxo-tab-menu__container__LePDW"};